import { init, PlatformName } from '@cbhq/client-analytics';

import { AMPLITUDE_API_KEY, APP_IS_PROD, APP_PROJECT_NAME, APP_VERSION } from './config';

export function initAnalytics() {
  init({
    amplitudeApiKey: AMPLITUDE_API_KEY,
    isProd: APP_IS_PROD,
    platform: PlatformName.web,
    projectName: APP_PROJECT_NAME,
    showDebugLogging: !APP_IS_PROD,
    version: APP_VERSION,
  });
}
